import { getCurrencyDecimals, getCurrencySymbol, getTenantCurrency } from "../../tenant/currency";

// Legacy symbol map kept for currency-service consumers; new code should use
// getCurrencySymbol from tenant/currency, which derives symbols from the ISO code.
export const currencyMap: Record<string, string> = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  NGN: "₦",
  JPY: "¥",
  INR: "₹",
  CNY: "¥",
  AUD: "A$",
  CAD: "C$",
  ZAR: "R",
  ZMW: "ZK", // ✅ Zambia
  // Add more as needed
};

export class Money {
  currency: string;
  amount: number;

  constructor(currency: string, amount: number);
  constructor(money: Money);
  constructor(currencyOrMoney: string | Money, amount?: number) {
    if (typeof currencyOrMoney === 'string') {
      this.currency = currencyOrMoney.toUpperCase();
      this.amount = amount ?? 0;
    } else {
      this.currency = currencyOrMoney.currency;
      this.amount = currencyOrMoney.amount;
    }
  }

  toLocaleString(): string {
    // A Money that arrives without a currency falls back to the utility's
    // configured currency (tenant branding), never to a hardcoded one.
    const currency = this.currency || getTenantCurrency();
    const symbol = getCurrencySymbol(currency);
    const decimals = getCurrencyDecimals(currency);

    // Format the number itself without currency symbol
    const formattedNumber = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(this.amount);

    // Decide symbol position: prefix (e.g., $100) or suffix (e.g., 100€)
    const symbolOnRight = ["EUR"].includes(currency);

    return symbolOnRight
      ? `${formattedNumber} ${symbol}`
      : `${symbol} ${formattedNumber}`;
  }
}